import 'plyr/dist/plyr.css';
import '../scss/application.scss';

// Lazy loading
import 'lazysizes/plugins/bgset/ls.bgset.js';
import 'lazysizes/plugins/respimg/ls.respimg.js';
import 'lazysizes';

// Nav
import './components/DesktopNav.js';
import './components/MobileNav.js';

// UI
import './components/Carousel.js';
import './components/hideBanner.js';

// Plugins
import './plugins/SocialShare.js';
import './plugins/Clipboard.js';

// SVG sprite injection
fetch('/dist/icons/icons.svg')
  .then((r) => r.text())
  .then((svg) => {
    const div = document.createElement('div');
    div.style.display = 'none';
    div.innerHTML = svg;
    document.body.insertBefore(div, document.body.firstChild);
  });

// Plyr video (lazy-loaded — only on pages that need it)
if (document.querySelector('.js-player')) {
  import('plyr').then(({ default: Plyr }) => {
    document.querySelectorAll('.js-player').forEach((el) => new Plyr(el));
  });
}

// Input has-value class
document.querySelectorAll('select, input').forEach((el) => {
  if (el.value) el.classList.add('has-value');
  el.addEventListener('change', () => {
    el.classList.toggle('has-value', Boolean(el.value));
  });
});

// Toggle sections
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.js-toggle-click');
  if (!toggle) return;
  const container = toggle.closest('.js-toggle-container');
  if (container) { container.classList.toggle('is-active'); e.preventDefault(); }
});
